import React from 'react';
import styled from 'styled-components/macro';
import { headerHeight } from 'utils/styleConstants';

const Error404 = styled.div`
  height: calc(100vh - ${headerHeight}px);
  justify-content: center;
  display: flex;
  align-items: center;
`;

export default () => (
  <Error404>
    <h2>404</h2>
  </Error404>
);
